<template>
    <a-layout id="components-layout-demo-top-side-2">
        <a-layout-header class="header">
            <div class="logo"/>
            <a-menu
                theme="dark"
                mode="horizontal"
                :default-selected-keys="['1']"
                :style="{ lineHeight: '64px' }"
            >
                <a-menu-item key="1">
                    <a-icon type="profile"/>
                    生成配置
                </a-menu-item>
            </a-menu>
        </a-layout-header>
        <a-layout>
            <a-layout style="padding: 0 24px 24px">
                <a-breadcrumb style="margin: 16px 0">
                </a-breadcrumb>
                <a-layout-content
                    :style="contentStyle"
                >
                    <a-row>
                        <!--                        :xs="2" :sm="4" :md="6" :lg="8" :xl="10"  9:6:9-->
                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="9" style="padding-left: 20px">
                            <a-row>
                                <a-col :span="24">
                                    <a-space>
                                        <a-button type="primary" @click="handleAdd">
                                            添加
                                        </a-button>
                                        <a-button type="danger" icon="delete" @click="clearData()">
                                            清空
                                        </a-button>
                                    </a-space>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="24">
                                    <div style="margin-top: 20px;margin-right: 20px">
                                        <a-table bordered :data-source="dataSource" :columns="columns" rowKey="id"
                                                 :pagination="false"
                                                 :scroll="{'y':contentHeight}"
                                        >
                                            <template slot="keyword" slot-scope="text, record">
                                                <editable-cell :text="text"
                                                               @change="onCellChange(record.id, 'keyword', $event)"/>
                                            </template>
                                            <template slot="operation" slot-scope="text, record">
                                                <a-popconfirm
                                                    v-if="dataSource.length"
                                                    title="确认删除?"
                                                    @confirm="() => onDelete(record.id)"
                                                >
                                                    <a href="javascript:;">删除</a>
                                                </a-popconfirm>
                                            </template>
                                            <template slot="bgChose" slot-scope="text, record">
                                                <color-chose :colors="text"
                                                             @chose="onCellChange(record.id,'bg',$event)"></color-chose>
                                            </template>
                                            <template slot="fgChose" slot-scope="text, record">
                                                <color-chose :colors="text"
                                                             @chose="onCellChange(record.id,'fg',$event)"></color-chose>
                                            </template>
                                            <template slot="enabled" slot-scope="text,record">
                                                <div>
                                                    <a-switch :default-checked="text"
                                                              @change="onCellChange(record.id,'enabled',$event)"/>
                                                </div>
                                            </template>
                                        </a-table>
                                    </div>
                                </a-col>
                            </a-row>
                        </a-col>
                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="6">
                            <a-row>
                                <a-col :span="12">
                                    <h2>配置数据</h2>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="24">
                                    <MonacoEditor
                                        :height="previewStyle.height.replace('px','')"
                                        language="typescript"
                                        :editorOptions="options"
                                        @codeChange="onCodeChange"
                                        @mounted="onMounted"
                                    >
                                    </MonacoEditor>
                                </a-col>
                            </a-row>
                        </a-col>
                        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="9" style="padding-left: 20px">
                            <a-row>
                                <a-col :span="4">
                                    <h2>效果预览</h2>
                                </a-col>
                                <a-col :span="20">
                                    <a-radio-group v-model="theme" @change="changeTheme">
                                        <a-radio-button value="0">
                                            Intellij Light
                                        </a-radio-button>
                                        <a-radio-button value="1">
                                            Windows 10 Light
                                        </a-radio-button>
                                        <a-radio-button value="2">
                                            Darcula
                                        </a-radio-button>
                                        <a-radio-button value="3">
                                            High contrast
                                        </a-radio-button>
                                    </a-radio-group>
                                </a-col>

                            </a-row>
                            <a-row>
                                <div :style="previewStyle">
                                    <sql-preview :data-source="dataSource"
                                                 :default-color="previewStyle.color"></sql-preview>
                                </div>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-layout-content>
            </a-layout>
        </a-layout>
        <a-drawer
            title="查看配置"
            placement="right"
            width="600"
            :closable="false"
            :visible="drawerVisible"
            @close="drawerOnClose"
        >
            <pre>{{ JSON.stringify(this.dataSource, null, 4) }}
            </pre>
        </a-drawer>

        <a-modal
            :visible="importModalVisible"
            @ok="importModalHandleOk"
            @cancel="importModalHandleCancel"
            cancelText="否"
            okText="是"
        >
            是否覆盖现有配置？
        </a-modal>
    </a-layout>
</template>
<script>
import EditableCell from "../components/EditableCell";
import ColorChose from "@/components/ColorChose";
import SqlPreview from "@/components/SqlPreview";
import MonacoEditor from 'vue-monaco-editor';
import {v4 as uuidv4} from 'uuid';


const clipboardy = require('clipboardy');

export default {
    components: {
        SqlPreview,
        ColorChose,
        EditableCell,
        MonacoEditor,
    },
    data() {
        return {
            contentStyle: {
                background: '#fff',
                padding: '24px',
                margin: 0,
                minHeight: '600px'
            },
            contentHeight: '600px',
            previewStyle: {
                border: '1px',
                background: '#2b2b2b',
                height: '600px',
                fontSize: '20px',
                color: '#bbbbbb',
                padding: '5px',
                overflowY: 'auto'
            },
            dataSource: [
                {"id": uuidv4(), "keyword": "INSERT", "enabled": true, "bg": "#29CC98", "fg": "#FFFFFF"},
                {"id": uuidv4(), "keyword": "UPDATE", "enabled": true, "bg": "#7693FF", "fg": "#FFFFFF"},
                {"id": uuidv4(), "keyword": "DELETE", "enabled": true, "bg": "#FF8997", "fg": "#FFFFFF"}
            ],
            count: 2,
            columns: [
                {
                    title: '关键字',
                    dataIndex: 'keyword',
                    width: '30%',
                    scopedSlots: {customRender: 'keyword'},
                },
                {
                    title: '背景色',
                    dataIndex: 'bg',
                    scopedSlots: {customRender: 'bgChose'},
                },
                {
                    title: '前景色',
                    dataIndex: 'fg',
                    scopedSlots: {customRender: 'fgChose'},
                },
                {
                    title: '是否启用',
                    dataIndex: 'enabled',
                    scopedSlots: {customRender: 'enabled'},
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    scopedSlots: {customRender: 'operation'},
                },
            ],
            theme: '2',
            previewColors: [
                '#ffffff', '#ffffff', '#2b2b2b', '#000000'
            ],
            previewContent: "",
            drawerVisible: false,
            code: "",
            importModalVisible: false,
            options: {},
            execOnCodeChange: false,
        };
    },
    methods: {
        getWindowHeight() {
            this.contentStyle.minHeight = (window.innerHeight - 120) + 'px';
            this.contentHeight = (window.innerHeight - 300) + 'px';
            this.previewStyle.height = (window.innerHeight - 240) + 'px';
        },
        onCellChange(key, dataIndex, value) {
            const dataSource = [...this.dataSource];
            const target = dataSource.find(item => item.id === key);
            if (target) {
                target[dataIndex] = value;
                this.dataSource = dataSource;
            }
            this.execOnCodeChange = false;
            this.reloadEditor();
        },
        onDelete(key) {
            const dataSource = [...this.dataSource];
            this.dataSource = dataSource.filter(item => item.id !== key);
            this.reloadEditor()
        },
        handleAdd() {
            const {count, dataSource} = this;
            const newData = {
                id: uuidv4(),
                keyword: '请修改关键字',
                enabled: true,
                bg: '#589DF6',
                fg: '#8A8A00',
            };
            this.dataSource = [...dataSource, newData];
            this.count = count + 1;
            this.reloadEditor()
        },
        importData(cover) {
            const {dataSource} = this;
            if (cover) {
                this.dataSource = [];
            }
            clipboardy.read().then((val) => {
                let jsonVal = JSON.parse(val);
                if (cover) {
                    this.dataSource = jsonVal;
                } else {
                    this.dataSource = [...dataSource, ...jsonVal];
                }
            });
        },
        clearData() {
            this.dataSource = []
            this.reloadEditor();
        },
        changeTheme(value) {
            this.previewStyle.background = this.previewColors[value.target.value]
            if (value.target.value < 2) {
                this.previewStyle.color = '#000000';
            } else {
                this.previewStyle.color = '#bbbbbb'
            }
        },
        drawerOnClose() {
            this.drawerVisible = false;
        },
        importModalHandleCancel() {
            this.importData(false)
            this.importModalVisible = false;
        },
        importModalHandleOk() {
            this.importData(true)
            this.importModalVisible = false;
        },
        onCodeChange(editor) {
            if (this.execOnCodeChange) {
                let value = JSON.parse(editor.getValue());
                value.forEach(v => {
                    v.id = uuidv4();
                })
                this.dataSource = [...value];
            }
            this.execOnCodeChange = true;
        },
        onMounted(editor) {
            this.editor = editor;
            this.reloadEditor()
        },
        reloadEditor() {
            let configData = JSON.stringify(this.dataSource);
            configData = JSON.parse(configData);
            configData.forEach(da => {
                delete da.id;
            })
            this.editor.setValue(JSON.stringify(configData, null, 4))
        }
    },
    beforeMount() {
        this.getWindowHeight();
    },
};
</script>

<style>
#components-layout-demo-top-side-2 .logo {
    width: 120px;
    height: 31px;
    background: rgba(255, 255, 255, 0.2);
    margin: 16px 28px 16px 0;
    float: left;
}
</style>
